import React from "react";
import "./Footer.css";
import { Typography } from "@mui/material";
import logoSvg from "../../Assests/Images/logo.svg";
import { Link } from "react-router-dom";

const year = new Date().getFullYear();

export default function Footer({ routes }) {
  return (
    <footer className="footer">
      {/* Main Footer Content */}
      <div className="footer-main">
        {/* Left Section */}
        <div className="footer-section footer-left">
          <div className="footer-logo">
            <img src={logoSvg} alt="SaafSafaiWale" className="footer-logo-img" />
            <span className="footer-logo-text">SaafSafaiWale</span>
          </div>
          <Typography className="footer-desc">
            Experience the joy of a spotless home & office space — choose our
            cleaning services for a sparkling, stress-free life!
          </Typography>
        </div>

        {/* Middle Section */}
        <div className="footer-section footer-links-container">
          <h4 className="footer-heading">Useful Links</h4>
          <ul className="footer-links">
            {routes.map(({ name, path, element, target }) =>
              element ? (
                <li key={"footerNavLink" + name}>
                  <Link to={path} target={target} className="footer-link">
                    {name}
                  </Link>
                </li>
              ) : null
            )}
          </ul>
        </div>

        {/* Right Section */}
        <div className="footer-section footer-contact">
          <h4 className="footer-heading">Contact Us</h4>
          <p className="footer-address">
            U-66, Rukmani Tower, Upadhyay Block, Shakarpur, Laxmi Nagar,
            Delhi-110092
          </p>
          <ul className="footer-contact-list">
            <li>
              <a href="tel:+91-9953614486" className="footer-contact-link">
                📞 +91 99536 14486
              </a>
            </li>
           <li>
              {/* <a href="tel:+919711775486" className="footer-contact-link"> */}
                {/* 📞 +91 97117 75486 */}
              {/* </a> */}
            </li>
            <li>
              <a
                href="mailto:info@Saafsafai53@gmail.com"
                className="footer-contact-link"
              >
                ✉️ Saafsafai53@gmail.com 
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>© {year} SaafSafaiWale | Designed by Rex Consulting</p>
      </div>
    </footer>
  );
}
